import { render, staticRenderFns } from "./projects-edit.vue?vue&type=template&id=80061856&"
import script from "./projects-edit.vue?vue&type=script&lang=js&"
export * from "./projects-edit.vue?vue&type=script&lang=js&"
import style0 from "./projects-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports